import { render, staticRenderFns } from "./report_stu.vue?vue&type=template&id=47172f0e&scoped=true&"
import script from "./report_stu.vue?vue&type=script&lang=js&"
export * from "./report_stu.vue?vue&type=script&lang=js&"
import style0 from "./report_stu.vue?vue&type=style&index=0&id=47172f0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47172f0e",
  null
  
)

export default component.exports